import React from 'react';
import {
  FDStack, FDLozenge,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { dataAttrs } from 'Helpers/Testing';
import {
  TaxDashboardWizardWrapper,
} from 'Views/Page/Content/Modal/Layouts/TaxDashboardWizard/Components/TaxDashboardWizardWrapper';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';

const Layout = () => {
  const { resource } = useMetaLayoutContext();

  let lozengeColor = 'info';

  if (resource.attr('gainLossType') === 'loss') {
    lozengeColor = 'success';
  }

  if (resource.attr('gainLossType') === 'gain') {
    lozengeColor = 'warning';
  }

  return (
    <TaxDashboardWizardWrapper>
      <FDStack direction="column" spacing={4}>
        <MetaControlField attr={'body'} {...dataAttrs('dashboard-review-kickoff-wizard-body')} />

        {/* Gains/Losses */}
        { resource.attr('gainLossAmount') && (
          <FDStack direction={'column'} spacing={1}>
            {resource.attr('gainLossTitle') && <FDLozenge label={resource.attr('gainLossTitle')} color={lozengeColor} />}
            <MetaControlField attr={'gainLossAmount'} />
          </FDStack>
        )}

        <MetaControlField attr={'disclosure'} {...dataAttrs('dashboard-review-kickoff-wizard-disclosure')} />
      </FDStack>
    </TaxDashboardWizardWrapper>
  );
};

export default Layout;
